export default __webpack_public_path__ + "static/media/defendant-1-2.fbcd3068.jpg";